import { useLocation } from 'react-router-dom'
import { RoutePath } from '@/routes'

function useSkeletonOnlyPath() {
  const { pathname } = useLocation()

  return (
    pathname.startsWith(RoutePath.History)
  )
}

export { useSkeletonOnlyPath }
